import { Chip } from "primereact/chip";
import { Divider } from "primereact/divider";
import { useFragment } from "react-relay";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import type { cartForm_OrderFragment$key } from "@relay/cartForm_OrderFragment.graphql";
import { ORDER_FRAGMENT } from "./cart-form.graphql";
import type { CartFormProps } from "./cart-form.types";
import { Paths } from "../../../../routes/paths";
import { H2Span } from "../../../../themes/font-tags";

export const CartForm = ({ orderFragmentRef }: CartFormProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	const { cart } = useFragment<cartForm_OrderFragment$key>(ORDER_FRAGMENT, orderFragmentRef);

	const selectedProducts = (cart?.selection.selectedProducts ?? []).filter(Boolean);
	const hasProducts = selectedProducts.length > 0;

	const selectedDiscountCodes = cart?.selection.selectedDiscountCodes ?? [];
	const hasDiscountCodes = selectedDiscountCodes.length > 0;

	const createProductOnClickHandler = (productId?: string) => () => {
		if (!productId) return;
		navigate(Paths.products.withId(productId).edit.path);
	};

	const renderProductChip = ({ product, amount }: (typeof selectedProducts)[number]) => {
		const label = `${product?.title} x ${amount}`;

		return (
			<Chip
				key={product?.id}
				label={label}
				onClick={createProductOnClickHandler(product?.id)}
			/>
		);
	};

	return (
		<div>
			{hasProducts && (
				<div>
					<H2Span>{t("order.products")}: </H2Span>
					{selectedProducts.map(renderProductChip)}
				</div>
			)}
			{hasDiscountCodes && (
				<>
					<Divider layout="horizontal" />
					<div>
						<H2Span>{t("order.discountCodes")}: </H2Span>
						{selectedDiscountCodes.map((selectedDiscountCode) => (
							<Chip key={selectedDiscountCode} label={selectedDiscountCode} />
						))}
					</div>
				</>
			)}
		</div>
	);
};
